module.exports = __webpack_public_path__ + "static/media/m-1-04.9cf451fa.svg";